import React from "react";
// import { Clock, ShieldCheck, UserCheck, IndianRupee } from "lucide-react";
import clock from "../../images/icons/driver.png";
import rup from "../../images/icons/rupee.png";
import safe from "../../images/icons/safe.png";
import timer from "../../images/icons/timer.png";
import car from "../../images/header/aboutCar.jpeg";
import { Fade } from "react-awesome-reveal";

const About = () => {
  return (
    <section className="max-w-8xl  md:px-[50px] lg:px-[120px] md:mx-auto mt-16 md:mt-20 pt-10 md:py-12  mx-4">
      {/* Services Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Fade direction="up" triggerOnce ascade damping={0.2}>
          {/* Card 1 */}
          <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
            <img
              src={timer}
              className="w-9 h-9 mb-3 md:mb-4"
              alt="24/7 Service"
            />
            <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
              24/7 Service
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-[#858585]">
              Book anytime, day or night. We are always available.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
            <img
              src={rup}
              className="w-9 h-9 mb-3 md:mb-4"
              alt="Affordable Pricing"
            />
            <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
              Affordable Pricing
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-[#858585]">
              Transparent pricing with no hidden charges.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
            <img
              src={safe}
              className="w-9 h-9 mb-3 md:mb-4"
              alt="Safe & Secure"
            />
            <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
              Safe & Secure
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-[#858585]">
              Insured rides with well-maintained vehicles.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
            <img
              src={clock}
              className="w-9 h-9 mb-3 md:mb-4"
              alt="Professional Driver"
            />
            <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
              Professional Driver
            </h3>
            <p className="text-xs sm:text-sm md:text-base text-[#858585]">
              Experienced drivers who prioritize your safety.
            </p>
          </div>
        </Fade>
      </div>

      <Fade direction="up" triggerOnce ascade damping={0.2}>
        {/* Header Section */}
        <div
          // id="about"
          className="text-center mt-16 md:mt-24  mb-10 flex flex-col justify-center items-center"
        >
          <p className="text-sm text-gray-500 mb-2 md:mb-0">About Us</p>
          {/* <h2 className="text-2xl text-center content-center md:max-w-[790px] md:text-[36px] md:h-[62px] font-bold text-gray-900 mb-2 md:mb-[24px]"> */}
          <h2 className="text-2xl text-center content-center md:text-4xl  md:h-[62px] font-bold text-gray-900 mb-6">
            Driven by Trust, Powered by Technology
          </h2>
          <p className="text-gray-600 md:max-w-[995px] font-medium items-center leading-relaxed text-[14px] md:text-[18px]">
            At Carzen Logistics, we redefine corporate travel with modern car
            rental solutions built for efficiency and comfort. We specialize in
            providing professional transportation services for MNCs, IT
            companies, and business executives — ensuring punctuality, safety,
            and a seamless experience at every mile.
          </p>
        </div>

        {/* Image Section */}
        <div className="rounded-2xl overflow-hidden shadow-md mb-0">
          <img
            src={car}
            alt="Fleet of Cars"
            className="w-full h-64 md:h-[436px] object-cover"
          />
        </div>

        {/* Services Section */}
      </Fade>
    </section>
  );
};

export default About;
